import { fetchme } from 'gso-fetchme';
import { getEntrypoint } from 'gso-get-entrypoint';
async function deleteToken() {
    const entrypoint = await getEntrypoint('petrus');
    return fetchme(entrypoint.links.token, {
        method: 'DELETE'
    });
}
export { deleteToken };
//# sourceMappingURL=petrus-proxy.js.map